"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollingTo = void 0;
var scrollingTo = function scrollingTo(_ref) {
  var deviceData = _ref.deviceData,
    scrollToId = _ref.scrollToId,
    chnageAnimateId = _ref.chnageAnimateId,
    delayScroll = _ref.delayScroll;
  if (chnageAnimateId) {
    chnageAnimateId(1);
  }
  var id = scrollToId;
  var deviceOffset = deviceData && deviceData.ismobiledevice ? 100 : 80;
  var element = document.querySelector(id);
  var sectionOffest = element && element.getBoundingClientRect().top + window.pageYOffset - deviceOffset;
  if (window.scrollY < sectionOffest) {
    window.scrollTo({
      top: sectionOffest,
      behavior: 'smooth'
    });
  } else {
    window.scrollTo(0, sectionOffest);
  }
  if (chnageAnimateId) {
    setTimeout(function () {
      return chnageAnimateId(0);
    }, 1000);
  }
};
exports.scrollingTo = scrollingTo;